module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1b636eacc3c2152c793b7100d0ef5f3d.png";